


























































import { Component, Vue, Ref } from "vue-property-decorator";
import SliderToggler from "_C/main/Step4/SliderToggler.vue";
import { InsuranceCard } from "@/services/index.defs";
import { ValidationRules } from "_P/validate";
@Component({
    components: { SliderToggler },
})
export default class CardInfoDisplay extends Vue {
    Rules = ValidationRules;

    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }
    fakeCard = {
        beginDate: this.card.beginDate,
        insuranceMonth: this.card.insuranceMonth,
    };

    insuranceMonthItems = [
        { value: 3, title: "3 месяца" },
        { value: 6, title: "6 месяцев" },
        { value: 9, title: "9 месяцев" },
        { value: 12, title: "12 месяцев" },
    ];
    get cardInfoText(): string {
        //с 10.01.2020 по 09.01.2021
        return `c ${new Date(this.card.beginDate)?.toLocaleDateString?.() ?? "--"} по ${this.card.endDate?.toLocaleDateString?.() ?? "--"}`;
    }
    @Ref("form") form: { validate: Function };
    applyChanges() {
        let isValid = this.form.validate();
        if (!isValid) {
            this.cancelChanges();
            return;
        }

        this.card.beginDate = this.fakeCard.beginDate;
        this.card.insuranceMonth = this.fakeCard.insuranceMonth;
    }
    cancelChanges() {
        this.fakeCard.beginDate = this.card.beginDate;
        this.fakeCard.insuranceMonth = this.card.insuranceMonth;
    }
    @Ref("st") st: SliderToggler;
    isEdit(): boolean{
        return this.st.isEdit
    }
}
